export const tokenKeyName = 'jwt';
export const jwtTokenLocalStorage = typeof localStorage !== 'undefined' ? localStorage.getItem(tokenKeyName) : '';
